<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb
          parentRouteName="PointList" 
          :extra-items="isReadOnly ? [
            '查看點數'
          ] : isEditing ? [
            '編輯點數'
          ] : [
            '新增點數'
          ]" 
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-overlay :show="showLoading">
          <b-card>
            <div class="row d-flex mb-4 mb-xl-2 justify-content-between">
              <h4 class="col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold">
                {{
                  isReadOnly ? "查看點數" : isEditing ? "編輯點數" : "新增點數"
                }}
              </h4>
              <div class="col-12 col-xl-8 mt-3">
                <b-form-group
                  label-cols="12"
                  label-cols-lg="2"
                  label-size="sm"
                  label="通路"
                >
                  <b-form-select
                    v-model="merchantId"
                    :options="merchants"
                    :disabled="isReadOnly"
                  ></b-form-select>
                </b-form-group>

                <b-form-group
                  label-cols="12"
                  label-cols-lg="2"
                  label-size="sm"
                  label="會員 id"
                >
                  <b-form-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="customerInfo"
                    disabled
                  ></b-form-input>
                  <b-form-invalid-feedback :state="!v$.point.customer_id.$error" >此欄位為必填</b-form-invalid-feedback>
                  <PointAddCustomer
                    :customerId="point.customer_id"
                    :merchantId="merchantId"
                    v-if="!isReadOnly"
                    @added="selectedCustomer"
                  ></PointAddCustomer>
                </b-form-group>

                <b-form-group
                  label-cols="12"
                  label-cols-lg="2"
                  label-size="sm"
                  label="訂單 id"
                >
                  <b-form-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="point.order_id"
                    :disabled="isReadOnly"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  label-cols="12"
                  label-cols-lg="2"
                  label-size="sm"
                  label="分店 id"
                >
                  <b-form-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="point.branch_id"
                    :disabled="isReadOnly"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  label-cols="12"
                  label-cols-lg="2"
                  label-size="sm"
                  label="點數"
                >
                  <b-form-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="point.point"
                    :disabled="isReadOnly"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="!v$.point.point.$error" >此欄位為必填且正整數</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group
                  label-cols="12"
                  label-cols-lg="2"
                  label-size="sm"
                  label="入點說明"
                >
                  <b-form-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="point.description"
                    :disabled="isReadOnly"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  label-cols="12"
                  label-cols-lg="2"
                  label-size="sm"
                  label="開始時間"
                >
                  <AppDateTimePicker
                    v-model="point.start_at"
                  ></AppDateTimePicker>
                </b-form-group>

                <b-form-group
                  label-cols="12"
                  label-cols-lg="2"
                  label-size="sm"
                  label="過期時間"
                >
                  <AppDateTimePicker
                    v-model="point.expired_at"
                  ></AppDateTimePicker>
                </b-form-group>

                <b-form-group
                  label-cols="12"
                  label-cols-lg="2"
                  label-size="sm"
                  label="活動 id"
                >
                  <b-form-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="point.event_id"
                    :disabled="isReadOnly"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  label-cols="12"
                  label-cols-lg="2"
                  label-size="sm"
                  label="source type"
                >
                  <b-form-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="point.source_type"
                    :disabled="isReadOnly"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  label-cols="12"
                  label-cols-lg="2"
                  label-size="sm"
                  label="source id"
                >
                  <b-form-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="point.source_id"
                    :disabled="isReadOnly"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <b-button
                class="mr-3"
                @click="handleCancel"
                variant="outline-danger"
              >
                返回
              </b-button>
              <b-button
                v-if="!isReadOnly"
                @click="handleSubmit"
                variant="success"
                :disabled="isSubmitting"
              >
                儲存
              </b-button>
            </div>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import useVuelidate from "@vuelidate/core";
import pointApi from "../../../apis/point";
import merchantApi from "../../../apis/merchant";
import PointAddCustomer from "@/pages/Dashboard/Point/PointAddCustomer.vue";
import AppDateTimePicker from "@/components/AppDateTimePicker";
import * as consts from "@/consts";
import { required, integer, minValue } from "@vuelidate/validators";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: {
    AppDateTimePicker,
    PointAddCustomer,
    BreadCrumb
  },

  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return {
      point: {
        customer_id: { required },
        point: { required, integer, minValue: minValue(1) },
      }
    };
  },

  data() {
    return {
      merchantId: null,
      merchants: [{ value: null, text: "請選擇" }],
      showLoading: false,
      isEditing: true,
      isSubmitting: false,
      validationErrors: null,
      customerInfo: null,
      point: {
        customer_id: null,
        order_id: null,
        branch_id: null,
        point: null,
        memo: null,
        description: null,
        start_at: null,
        expired_at: null,
        event_id: null,
        source_type: null,
        source_id: null,
      },
    };
  },

  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
      defaultMerchantType: (state) => state.defaultMerchantType,
    }),
    ...mapGetters('route', ['routeQuery']),

    isReadOnly() {
      return this.$route.name === "PointView";
    },
  },
  mounted() {
    this.fetchMerchants();
    if (!this.$route.params.point_id) {
      this.clearPoint();
      this.isEditing = false;
    } else {
      this.fetchPoint();
      this.merchantId = this.$route.params.merchant_id;
      this.isEditing = true;
    }
  },
  methods: {
    async fetchPoint() {
      this.showLoading = true;
      const response = await pointApi.getPoint(
        this.$route.params.merchant_id,
        this.$route.params.point_id
      );
      this.point = response.data.data;
      this.customerInfo = this.point.customer_name;
      this.showLoading = false;
    },

    clearPoint() {
      this.point.tag = null;
      this.point.outer_code = null;
      this.point.customers_count = 0;
    },
    async handleSubmit() {
      const result = await this.v$.$validate();
      if (!result) return;

      this.isSubmitting = true;
      try {
        if (this.isEditing) {
          let response = await pointApi.updatePoint(
            this.merchantId,
            this.point
          );
          if (response.status && response.status === 200) {
            this.$swal.fire({
              title: "更新成功",
              type: "success",
            });

            this.$router.push({name: "PointList", query: this.routeQuery});
          }
        } else {
          let response = await pointApi.storePoint(this.merchantId, this.point);

          if (response.status && response.status >= 200) {
            this.$swal.fire({
              title: "新增成功",
              type: "success",
            });

            this.$router.push({name: "PointList", query: this.routeQuery});
          }
        }
      } catch (error) {
        if (error.response.status === 422 && error.response.data.message) {
          this.validationErrors = error.response.data.message;
        } else {
          this.$swal.fire({
            title: this.isEditing ? "更新失敗" : "新增失敗",
            type: "error",
          });
        }
      } finally {
        this.isSubmitting = false;
      }
    },
    selectedCustomer(value) {
      this.customerInfo = `${value.name}`;
      this.point.customer_id = value.id;
      this.$forceUpdate();
    },
    handleCancel() {
      this.$router.push({name: "PointList", query: this.routeQuery});
    },
    async fetchMerchants() {
      const { data } = await merchantApi.list();

      this.merchants = [
        { value: null, text: "請選擇" },
        ...data.data.map((merchant) => {
          return {
            value: merchant.id,
            type: merchant.type,
            text: `${merchant.name} (${merchant.type_name})`,
          };
        }),
      ];

      this.merchantId = this.merchants.find((merchant) => merchant.type === this.defaultMerchantType)?.value ??
        this.merchants.find((merchant) => merchant.type === consts.MERCHANT_TYPES.LINE_TYPE)?.value ;
    },
  },
};
</script>
